import React from "react";
import { PartCategoryApi } from "src/api/generated/erp/parts/categories/partCategoryApi";
import { PartCategory } from "src/api/generated/erp/db/types/tables/partCategory";
import i18n from "i18next";
import { CrudActionButtons } from "src/components/common/crud/CrudActionButtons";
import { Box } from "@mui/material";
import { AsyncFunction } from "src/types/functions.ts";
import { PartCategoryFormProps } from "src/components/views/erp/parts/partCategories/PartCategoryForm.tsx";

export interface PartCategoriesActionsProps {
	selectedPartCategory: PartCategory | null;
	setSelectedPartCategory: React.Dispatch<React.SetStateAction<PartCategory | null>>;
	refreshPartCategories: AsyncFunction<void, PartCategory[]>;
	openPartCategoryFormDialog: (params: Partial<PartCategoryFormProps>) => void;
}

export const PartCategoriesActions = ({
										  selectedPartCategory,
										  refreshPartCategories,
										  setSelectedPartCategory,
										  openPartCategoryFormDialog
									  }: PartCategoriesActionsProps) => {
	return (
		<Box
			sx={{
				display: "flex"
			}}
		>
			<CrudActionButtons
				refresh={{
					type: "enabled",
					action: async () => {
						await refreshPartCategories();
					}
				}}
				add={{
					type: "enabled",
					action: () => {
						openPartCategoryFormDialog({});
					}
				}}
				remove={selectedPartCategory === null
					? {
						type: "disabled",
						tooltip: i18n.t("select_part_category")
					}
					: {
						type: "enabled",
						action: async () => {
							await PartCategoryApi.delete_({
								partCategoryId: selectedPartCategory.partCategoryId
							});
							setSelectedPartCategory(null);
							await refreshPartCategories();
						}
					}}
				edit={selectedPartCategory === null
					? {
						type: "disabled",
						tooltip: i18n.t("select_part_category")
					}
					: {
						type: "enabled",
						action: () => {
							openPartCategoryFormDialog({
								partCategoryId: selectedPartCategory?.partCategoryId
							});
						}
					}}
			/>
		</Box>
	);
};
